import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

interface LogoPreviewProps {
  logoBase64: string | null;
}

export const LogoPreview = ({ logoBase64 }: LogoPreviewProps) => {
  const { t } = useTranslation();
  if (!logoBase64) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <Chip
          label={t("preferences.uiBranding.noLogo")}
          size="small"
          variant="outlined"
          sx={{
            fontSize: "0.7rem",
            fontWeight: 500,
            borderColor: "grey.300",
            color: "text.secondary",
          }}
        />
      </Box>
    );
  }
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 0.5,
          borderRadius: 1,
          backgroundColor: "grey.50",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Box
          component="img"
          src={logoBase64}
          alt={t("preferences.uiBranding.logo")}
          sx={{
            maxWidth: 50,
            maxHeight: 28,
            objectFit: "contain",
          }}
        />
      </Box>
    </Box>
  );
};
